// import React, { useState } from "react";
import styles from './Style.module.css'

const Transactions = () => {
	// const [loading, setLoading] = useState(true);

	return (
		<>
			<div className={`${styles.bookingsContainer} header-sapce`}>
				Transactions
			</div>
		</>
	);
};

export default Transactions;
